export const staticOtpUrl = (baseUrl) => `${baseUrl}/configurations/static-otp/`;

export const mobilesText = (mobiles) => (mobiles || []).join("\n");

export const staticOtpError = ({ enabled, anyMobile, mobiles }) => {
  const listed = String(mobiles ?? "").split(/[,;\n]+/).some((entry) => entry.trim() !== "");
  if (enabled && !anyMobile && !listed) return "List at least one test number before switching it on";
  return null;
};
